import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from "../../../app/utilities/helpers";
import GetProxy from "../../../app/GetProxy";

const proxy = GetProxy();
const cookies = new Cookies();

export const AvailabilityZone = createAsyncThunk(
  "post/AvailabilityZone",
  async (props) => {
    const { payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/AwsEc2ResiliencyInfo/currentAZMap`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => {
        const result = res.json();
        return result;
      })
      .catch((err) => {
        return err;
      });
    handleResponseCode(res);
    return res;
  }
);
export const AvailabilityZoneTable = createAsyncThunk(
  "post/AvailabilityZoneTable",
  async (props) => {
    const { payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/AwsEc2ResiliencyInfo/currentAZMapDrillDown`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => {
        const result = res.json();
        return result;
      })
      .catch((err) => {
        return err;
      });
    handleResponseCode(res);
    return res;
  }
);

export const InstanceStatusSummaryApi = createAsyncThunk(
    "post/InstanceStatusSummary",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        const res = await fetch(`${proxy}/api/v1/AwsEc2ResiliencyInfo/instanceStatus`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "DTOP-API-TOKEN": Apitoken,
                USERNAME: User,
            },
            body: JSON.stringify(payload)
        }).then(res => {
            const result = res.json();
            return result;
        })
            .catch(err => {
                return err;
            });
        handleResponseCode(res);
        return res;

});

export const ApplicationDowntimeApi = createAsyncThunk(
    "post/ApplicationDowntime",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        const res = await fetch(`${proxy}/api/v1/AwsEc2ResiliencyInfo/getInstanceTimelineStatus`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "DTOP-API-TOKEN": Apitoken,
                USERNAME: User,
            },
            body: JSON.stringify(payload)
        }).then(res => {
            const result = res.json();
            return result;
        })
            .catch(err => {
                return err;
            });
        handleResponseCode(res);
        return res;

});

export const RecoveryInsightsApi = createAsyncThunk(
    "post/RecoveryInsightsApi",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        const res = await fetch(`${proxy}/api/v1/AwsEc2ResiliencyInfo/instanceInsights`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "DTOP-API-TOKEN": Apitoken,
                USERNAME: User,
            },
            body: JSON.stringify(payload)
        }).then(res => {
            const result = res.json();
            return result;
        })
            .catch(err => {
                return err;
            });
        handleResponseCode(res);
        return res;

});

export const RecoveryInsightsTableApi = createAsyncThunk(
    "post/RecoveryInsightsTableApi",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        const res = await fetch(`${proxy}/api/v1/AwsEc2ResiliencyInfo/instanceInsightDrillDown`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "DTOP-API-TOKEN": Apitoken,
                USERNAME: User,
            },
            body: JSON.stringify(payload)
        }).then(res => {
            const result = res.json();
            return result;
        })
            .catch(err => {
                return err;
            });
        handleResponseCode(res);
        return res;

});

export const ApplicationAvailabilityApi = createAsyncThunk(
    "post/ApplicationAvailabilityApi",
    async (props) => {
        const { payload } = props;
        const Apitoken = cookies.get("apitoken");
        const User = cookies.get("username");
        const res = await fetch(`${proxy}/api/v1/AwsEc2ResiliencyInfo/applicationAvailability`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "DTOP-API-TOKEN": Apitoken,
                USERNAME: User,
            },
            body: JSON.stringify(payload)
        }).then(res => {
            const result = res.json();
            return result;
        })
            .catch(err => {
                return err;
            });
        handleResponseCode(res);
        return res;

});
export const DetailsTableApi = createAsyncThunk(
  "post/DetailsTableApi",
  async (props) => {
    const { payload, pageNumber, itemsPerPage } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/AwsEc2ResiliencyInfo/awsInstanceDetailsList/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "DTOP-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
      .then((res) => {
        const result = res.json();
        return result;
      })
      .catch((err) => {
        return err;
      });
    handleResponseCode(res);
    return res;
  }
);


export const initialState = {
  AvailabilityZoneData: [],
  AvailabilityZoneDataLoading: false,
  AvailabilityZoneTableData:[],
  AvailabilityZoneTableLoading:false,
  InstanceStatusDataLoading: false,
  InstanceStatusData:[],
  ApplicationAvailabilityLoading:false,
  ApplicationAvailabilityData:[],
  ApplicationDowntimeLoading:false,
  ApplicationDowntimeData : [],
  RecoveryInsightsLoading: false,
  RecoveryInsightsData : [],
  RecoveryInsightsTableLoading: false,
  RecoveryInsightsTableData: [],
  DetailsTableData:[],
  DetailsTableLoading:false
};

export const ResilencySlice = createSlice({
  name: "ResilencySlice",
  initialState,
  reducers: {
    resetResilency_InitalData: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AvailabilityZone.pending, (state) => {
        state.AvailabilityZoneDataLoading = true;
      })
      .addCase(AvailabilityZone.fulfilled, (state, action) => {
        state.AvailabilityZoneData = action.payload;
        state.AvailabilityZoneDataLoading = false;
      })
      .addCase(AvailabilityZone.rejected, (state) => {
        state.AvailabilityZoneDataLoading = false;
      })
      //AvailabilityZoneTable
      .addCase(AvailabilityZoneTable.pending, (state) => {
        state.AvailabilityZoneTableLoading = true;
      })
      .addCase(AvailabilityZoneTable.fulfilled, (state, action) => {
        state.AvailabilityZoneTableData = action.payload;
        state.AvailabilityZoneTableLoading = false;
      })
      .addCase(AvailabilityZoneTable.rejected, (state) => {
        state.AvailabilityZoneDataLoading = false;
      })
      .addCase(InstanceStatusSummaryApi.pending, (state) => {
        state.InstanceStatusDataLoading = true;
      })
      .addCase(InstanceStatusSummaryApi.fulfilled, (state, action) => {
        state.InstanceStatusData = action.payload;
        state.InstanceStatusDataLoading = false;
      })
      .addCase(InstanceStatusSummaryApi.rejected, (state) => {
        state.InstanceStatusDataLoading = false;
      })

      .addCase(ApplicationAvailabilityApi.pending, (state) => {
        state.ApplicationAvailabilityLoading = true;
      })
      .addCase(ApplicationAvailabilityApi.fulfilled, (state, action) => {
        state.ApplicationAvailabilityData = action.payload;
        state.ApplicationAvailabilityLoading = false;
      })
      .addCase(ApplicationAvailabilityApi.rejected, (state) => {
        state.AvailabilityZoneDataLoading = false;
      })

      .addCase(ApplicationDowntimeApi.pending, (state) => {
        state.ApplicationDowntimeLoading = true;
      })
      .addCase(ApplicationDowntimeApi.fulfilled, (state, action) => {
        state.ApplicationDowntimeData = action.payload;
        state.ApplicationDowntimeLoading = false;
      })
      .addCase(ApplicationDowntimeApi.rejected, (state) => {
        state.ApplicationDowntimeLoading = false;
      })

      .addCase(RecoveryInsightsApi.pending, (state) => {
        state.RecoveryInsightsLoading = true;
      })
      .addCase(RecoveryInsightsApi.fulfilled, (state, action) => {
        state.RecoveryInsightsData = action.payload;
        state.RecoveryInsightsLoading = false;
      })
      .addCase(RecoveryInsightsApi.rejected, (state) => {
        state.RecoveryInsightsLoading = false;
      })

      .addCase(RecoveryInsightsTableApi.pending, (state) => {
        state.RecoveryInsightsTableLoading = true;
      })
      .addCase(RecoveryInsightsTableApi.fulfilled, (state, action) => {
        state.RecoveryInsightsTableData = action.payload;
        state.RecoveryInsightsTableLoading = false;
      })
      .addCase(RecoveryInsightsTableApi.rejected, (state) => {
        state.RecoveryInsightsTableLoading = false;
      })

      .addCase(DetailsTableApi.pending, (state) => {
        state.DetailsTableLoading = true;
      })
      .addCase(DetailsTableApi.fulfilled, (state, action) => {
        state.DetailsTableData = action.payload;
        state.DetailsTableLoading = false;
      })
      .addCase(DetailsTableApi.rejected, (state) => {
        state.AvailabilityZoneDataLoading = false;
      });
    }
});

export const { resetResilency_InitalData } = ResilencySlice.actions;
export default ResilencySlice.reducer;
